import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'scaffold-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  standalone: false,
})
export class PaginatorComponent implements OnInit {
  _count = 1;
  _perPage = 15;
  @Input()
  set perPage(count: number) {
    this._perPage = count;
    this.calcPageCount();
  }
  get perPage(): number {
    return this._perPage;
  }
  @Input() activePage = 1;
  @Input() disabled = false;
  @Output() activePageChange: EventEmitter<number> = new EventEmitter();
  pageCount = 1;
  @Input()
  set itemCount(count: number) {
    this._count = count;
    this.calcPageCount();
  }
  get itemCount(): number {
    return this._count;
  }

  calcPageCount() {
    if (!this.itemCount) {
      this.pageCount = this.activePage;
    } else {
      this.pageCount = Math.ceil(this.itemCount / this.perPage);
    }
  }

  constructor() {}

  setPage(page) {
    if (this.disabled) return;
    if (this.itemCount) {
      this.activePage = page;
      this.activePageChange.emit(page);
    }
  }
  ngOnInit() {}
}
